import { useEntityAPI } from '../../../redux/entity-api.hook';
import { projectTagAPI } from '../redux/project-tag.slice';

export function useProjectTags() {
  return useEntityAPI(projectTagAPI);
}
